/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionDto } from '../../models/subscription-dto';
import { UpdateSeatAssignmentsRequest } from '../../models/update-seat-assignments-request';

export interface BillingSubscriptionUpdateSeatsPost$Plain$Params {
      body?: UpdateSeatAssignmentsRequest
}

export function billingSubscriptionUpdateSeatsPost$Plain(http: HttpClient, rootUrl: string, params?: BillingSubscriptionUpdateSeatsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, billingSubscriptionUpdateSeatsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionDto>;
    })
  );
}

billingSubscriptionUpdateSeatsPost$Plain.PATH = '/billing/subscription/update-seats';
